export const defaultValuesForm = (currentProduct: Partial<any> | undefined) => ({
  cash: currentProduct?.cash || 0,
  creditCard: currentProduct?.creditCard || 0,
  transference: currentProduct?.transference || 0,
});
